const lang = {
  select_department: '部署を選択してください',
  business: '運用メニュー',
  management: '管理者メニュー',
  business_short: '運用',
  management_short: '管理者',
}

export default lang
